import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { useLayoutContext } from '../context/LayoutContext';

const Layout = ({ children }) => {
  const [headerClass, setHeaderClass] = useState('');
  const { layoutState, updateLayoutState } = useLayoutContext();
  const location = useLocation();

  const {
    layoutType,
    leftSidebarType,
    layoutModeType,
    layoutWidthType,
    layoutPositionType,
    topbarThemeType,
    leftsidbarSizeType,
    leftSidebarViewType,
    sidebarVisibilitytype,
  } = layoutState;

  // مدیریت کلاس header در اسکرول
  useEffect(() => {
    const scrollNavigation = () => {
      const scrollup = document.documentElement.scrollTop;
      setHeaderClass(scrollup > 50 ? 'topbar-shadow' : '');
    };
    window.addEventListener('scroll', scrollNavigation);
    return () => window.removeEventListener('scroll', scrollNavigation);
  }, []);

  // اعمال تنظیمات layout
  useEffect(() => {
    window.dispatchEvent(new Event('resize'));
    document.documentElement.setAttribute('data-layout', layoutType);
    document.documentElement.setAttribute('data-sidebar', leftSidebarType);
    document.documentElement.setAttribute('data-bs-theme', layoutModeType);
    document.documentElement.setAttribute('data-layout-width', layoutWidthType);
    document.documentElement.setAttribute('data-layout-position', layoutPositionType);
    document.documentElement.setAttribute('data-topbar', topbarThemeType);
    document.documentElement.setAttribute('data-sidebar-size', leftsidbarSizeType);
    document.documentElement.setAttribute('data-sidebar-visibility', sidebarVisibilitytype);
  }, [
    layoutType,
    leftSidebarType,
    layoutModeType,
    layoutWidthType,
    layoutPositionType,
    topbarThemeType,
    leftsidbarSizeType,
    leftSidebarViewType,
    sidebarVisibilitytype,
  ]);

  // تغییر حالت روشن/تیره
  const onChangeLayoutMode = (value) => {
    updateLayoutState({ layoutModeType: value });
  };

  // مدیریت آیکون همبرگر در حالت‌های مختلف
  useEffect(() => {
    const hamburgerIcon = document.querySelector('.hamburger-icon');
    if (sidebarVisibilitytype === 'show' || layoutType === 'vertical') {
      hamburgerIcon?.classList.remove('open');
    } else {
      hamburgerIcon?.classList.add('open');
    }
  }, [sidebarVisibilitytype, layoutType]);

  return (
    <div id="layout-wrapper">
      <Header
        headerClass={headerClass}
        layoutModeType={layoutModeType}
        onChangeLayoutMode={onChangeLayoutMode}
      />
      <Sidebar layoutType={layoutType} />
      <div className="main-content">
        {children}
        <Footer />
      </div>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
};

export default Layout;